import { useState, useEffect } from "react";
import Pagination from "components/common/pagination";

import NoticeListProps from "types/notice";
import { apiPost } from "apis/api";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

interface ParentProps  {
  intType : number;
}

const NoticeList = ({intType}: ParentProps) => {
  const [noticeList, setNoticeList] = useState<NoticeListProps[]>([]);
  const [intPage, setIntPage] = useState<number>(1);
  const [intPageSize, setIntPageSize] = useState<number>(
    intType === 0 ? 6 : intType === 11 ? 4 : 10
  );
  const [totalCount, setTotalCount] = useState<number>(0);
  const [totalPageCount, setTotalPageCount] = useState<number>(0);
  const [startPage, setStartPage] = useState<number>(0);

  const paramData = {
    intType,
    intPage,
    intPageSize,
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiPost('/board/getNoticeList', JSON.stringify(paramData)) as { resultList: NoticeListProps[] };
        setNoticeList(response.resultList);

        if (response.resultList.length > 0) {
          const { TotalCount, TotalPageCount, StartPage } = response.resultList[0];
          setTotalCount(TotalCount);
          setTotalPageCount(TotalPageCount);
          setStartPage(StartPage);
        }
      } catch (error) {
        console.error(axios.isAxiosError(error) ? error.message : error);
      }
    };

    fetchData();
  }, [intPage]);

  const navigate = useNavigate();

  const handleDetailPost = ({ item }: { item: NoticeListProps }) => {
    navigate('/board/noticeView', {
      state: {
        noticeIdx: `${item.BoardIndex}`,
      },
    });
  };

  if(intType === 0 || intType === 11) {
    return (
      <div className="container">
        <div className={`container-img-grid ${intType === 11 ? 'col4' : 'col3'}`}>
        
          {
            noticeList?.map((item, index) => {
              return (
                <div className="img-style" key={index}>
                  <div className="img-inner bgF7F7F7">
                    <img src={`${item.BoardFile}`} alt="News Image" onClick={() => handleDetailPost({ item })}/>
                  </div>
                  <div className="img-text">
                    {item.BoardTitle}                    
                  </div>
                </div>
              );
              return null;
            })
          }
        </div>
        <div style={intType === 11 ? {display: "none"} : {}}>
          <Pagination  intPage={intPage} intPageSize={intPageSize} totalPageCount={totalPageCount} startPage={startPage} setIntPage={setIntPage} />
        </div>
      </div>
    );
  }else{
    return (
      <div className="notice">
        <div className={`noticelist`}>
          <div className={`noticeItem top`}>
            <div className="notice-no">No.</div>
            <div className="title textoveflow">제목</div>
            <div className="writer">작성자</div>
            <div className="regdate">등록일</div>
          </div>
            {
              noticeList?.map((item, index) => {
              
                  return (
                    <div className={`noticeItem notice`} key={index}>
                      <div className="notice-no">{totalCount - ((intPageSize * (intPage - 1)) + index)}</div>
                      <div className="title textoveflow" onClick={() => handleDetailPost({ item })}>{item.BoardTitle}</div>
                      <div className="writer"><label className="mo">작성자 : </label>{item.BoardWriter}</div>
                      <div className="regdate"><label className="mo">등록일 : </label>{item.BoardRegDate}</div>
                    </div>
                  );

                return null;
              })
            }
        </div>
        <div style={intType === 11 ? {display: "none"} : {}}>
          <Pagination  intPage={intPage} intPageSize={intPageSize} totalPageCount={totalPageCount} startPage={startPage} setIntPage={setIntPage} />
        </div>
        
      </div>
    );
  }
};

export default NoticeList;
